import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(theme => ({
  calendar: {
    width: '100% !important',
  },
}))
